// ABOUTME: Hook for using toast notifications from context
// ABOUTME: Provides type-safe access to toast functionality

import { useContext } from "react";
import { ToastContext } from "../contexts/ToastContextDefinition";

export const useToast = () => {
  const context = useContext(ToastContext);
  if (context === undefined) {
    throw new Error("useToast must be used within a ToastProvider");
  }
  return context;
};
